import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

const SearchBar = () => {
  const [inputId, setInputId] = useState("");

  const handleSearch = () => {
    if (inputId.trim()) {
      window.open(`/belgelerim/${inputId}`, "_blank");
      setInputId("");
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "80%",
        margin: "0 auto",
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center',
        padding: 2,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Box display="flex" alignItems="center" gap={2} width="100%">
        <TextField
          label="Sınava giriş kodunuzu giriniz..."
          variant="outlined"
          value={inputId}
          onChange={(e) => setInputId(e.target.value)}
          fullWidth
        />
        <Button variant="contained" color="primary" onClick={handleSearch}>
          Sorgula
        </Button>
      </Box>
    </Box>
  );
};

export default SearchBar;
